// extracted by mini-css-extract-plugin
export var content = "MenuItem-module--content--97fa3";
export var label = "MenuItem-module--label--8eb8c";
export var link = "MenuItem-module--link--806bb";
export var wrapper = "MenuItem-module--wrapper--665d2";